import { render, staticRenderFns } from "./pageGoodsModule.vue?vue&type=template&id=71188a79&scoped=true"
import script from "./pageGoodsModule.vue?vue&type=script&lang=js"
export * from "./pageGoodsModule.vue?vue&type=script&lang=js"
import style0 from "./pageGoodsModule.vue?vue&type=style&index=0&id=71188a79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71188a79",
  null
  
)

export default component.exports